module.exports = __webpack_public_path__ + "img/2.acfaf77a.jpg";